import { MARQUEE_ITEMS } from "../lib/data";

export const Marquee = () => (
    <div className="relative border-y border-gold/20 bg-noir-surface py-5 overflow-hidden" aria-hidden="true" data-testid="editorial-marquee">
        <div className="marquee-track">
            {[...MARQUEE_ITEMS, ...MARQUEE_ITEMS].map((item, i) => (
                <span key={i} className="marquee-item">
                    <span className="inline-block h-2 w-2 rounded-[2px] bg-hotpink shadow-[0_0_10px_rgba(255,255,255,0.8)]" aria-hidden="true" />
                    {item}
                </span>
            ))}
        </div>
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-noir-surface to-transparent" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-noir-surface to-transparent" />
    </div>
);
